// extracted by mini-css-extract-plugin
module.exports = {"companiesDisplay":"companiesDisplay-BLykH8nfDNtryyFsy8w73"};